import { ElementType } from 'react';

import {
  AccesibilityIcon,
  ActivityIcon,
  AlarmClockIcon,
  AlertFillIcon,
  AlertIcon,
  AnchorIcon,
  AppsIcon,
  ArchiveIcon,
  ArrowDownIcon,
  ArrowDownLeftIcon,
  ArrowDownRightIcon,
  ArrowHeadDownIcon,
  ArrowHeadLeftIcon,
  ArrowHeadRightIcon,
  ArrowHeadUpIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  ArrowUpLeftIcon,
  ArrowUpRightIcon,
  AttachmentIcon,
  BackgroundIcon,
  BackspaceIcon,
  BackwardIcon,
  BankIcon,
  BarIcon,
  BatteryChargingIcon,
  BatteryEmptyIcon,
  BatteryFullIcon,
  BatteryLowIcon,
  BatteryMediumIcon,
  BellIcon,
  BlockIcon,
  BluetoothIcon,
  BluetoothOffIcon,
  BoltIcon,
  BookIcon,
  BookmarkIcon,
  BorderAllIcon,
  BorderBottomIcon,
  BorderHorizontalIcon,
  BorderInnerIcon,
  BorderLeftIcon,
  BorderRightIcon,
  BorderStyleIcon,
  BorderTopIcon,
  BorderVerticalIcon,
  BracketsCurlyIcon,
  BrainIcon,
  BroadcastIcon,
  BrushIcon,
  BugIcon,
  BulbIcon,
  CalculatorIcon,
  CalendarIcon,
  ChartIcon,
  ChartLineIcon,
  ChartPieIcon,
  ChatIcon,
  CompassIcon,
  EmojiBigSmileIcon,
  EmojiSadIcon,
  EmojiSmileIcon,
  EnglishIcon,
  FileIcon,
  FrenchIcon,
  GermanIcon,
  GlobeIcon,
  HeadphonesIcon,
  HeartIcon,
  HourglassIcon,
  MailIcon,
  MegaphoneIcon,
  MessageIcon,
  MicrophoneIcon,
  PaperplaneIcon,
  PhoneCallIcon,
  QuestionIcon,
  ReceiptIcon,
  SearchIcon,
  SmileIcon,
  SpanishIcon,
  SpeedmeterIcon,
  SuitcaseIcon,
  SwedishIcon,
  TargetIcon,
  TimeClockIcon,
  TreeIcon,
  UserIcon,
  UsersIcon,
} from '@/assets/icons';

export const iconByName: Record<string, ElementType> = {
  border: BorderAllIcon,
  calculate: CalculatorIcon,
  calculator: CalculatorIcon,
  math: CalculatorIcon,
  bulb: BulbIcon,
  idea: BulbIcon,
  light: BulbIcon,
  brush: BrushIcon,
  bug: BugIcon,
  problem: BugIcon,
  paint_brush: BrushIcon,
  painting: BrushIcon,
  antenna: BroadcastIcon,
  broadcast: BroadcastIcon,
  signal: BroadcastIcon,
  tower: BroadcastIcon,
  brain: BrainIcon,
  mind: BrainIcon,
  think: BrainIcon,
  'brackets-curly': BracketsCurlyIcon,
  'border-vertical': BorderVerticalIcon,
  'border-top': BorderTopIcon,
  'border-style': BorderStyleIcon,
  'border-right': BorderRightIcon,
  'border-left': BorderLeftIcon,
  'border-inner': BorderInnerIcon,
  'border-horizontal': BorderHorizontalIcon,
  'border-bottom': BorderBottomIcon,
  accesibility: AccesibilityIcon,
  inclusive: AccesibilityIcon,
  handicap: AccesibilityIcon,
  equal: AccesibilityIcon,
  activity: ActivityIcon,
  pulse: ActivityIcon,
  heart_rate: ActivityIcon,
  vitality: ActivityIcon,
  alarm: AlarmClockIcon,
  clock: AlarmClockIcon,
  alert: AlertIcon,
  warning: AlertIcon,
  attention: AlertIcon,
  'alert-fill': AlertFillIcon,
  anchor: AnchorIcon,
  apps: AppsIcon,
  applications: AppsIcon,
  blocks: AppsIcon,
  archive: ArchiveIcon,
  box: ArchiveIcon,
  'arrow-down': ArrowDownIcon,
  'arrow-down-left': ArrowDownLeftIcon,
  'arrow-down-right': ArrowDownRightIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-right': ArrowRightIcon,
  'arrow-up': ArrowUpIcon,
  'arrow-up-left': ArrowUpLeftIcon,
  'arrow-up-right': ArrowUpRightIcon,
  'arrowhead-down': ArrowHeadDownIcon,
  'arrowhead-up': ArrowHeadUpIcon,
  'arrowhead-left': ArrowHeadLeftIcon,
  'arrowhead-right': ArrowHeadRightIcon,
  attachment: AttachmentIcon,
  paper_clip: AttachmentIcon,
  files: AttachmentIcon,
  background: BackgroundIcon,
  theme: BackgroundIcon,
  wallpaper: BackgroundIcon,
  backspace: BackspaceIcon,
  clear: BackspaceIcon,
  delete: BackspaceIcon,
  back: BackwardIcon,
  backward: BackwardIcon,
  prev: BackwardIcon,
  previous: BackwardIcon,
  bank: BankIcon,
  building: BankIcon,
  business: BankIcon,
  finance: BankIcon,
  savings: BankIcon,
  'battery-charging': BatteryChargingIcon,
  battery: BatteryChargingIcon,
  charging: BatteryChargingIcon,
  'battery-empty': BatteryEmptyIcon,
  'battery-full': BatteryFullIcon,
  'battery-low': BatteryLowIcon,
  'battery-medium': BatteryMediumIcon,
  bell: BellIcon,
  notification: BellIcon,
  block: BlockIcon,
  blocked: BlockIcon,
  disabled: BlockIcon,
  bluetooth: BluetoothIcon,
  'bluetooth-off': BluetoothOffIcon,
  bolt: BoltIcon,
  electricity: BoltIcon,
  power: BoltIcon,
  book: BookIcon,
  dictionary: BookIcon,
  bookmark: BookmarkIcon,
  meter: SpeedmeterIcon,
  speedmeter: SpeedmeterIcon,
  briefcase: SuitcaseIcon,
  suitcase: SuitcaseIcon,
  gauge_meter: ChartPieIcon,
  team_members: UsersIcon,
  chat_bubbles: ChatIcon,
  smile: SmileIcon,
  target: TargetIcon,
  users: UserIcon,
  chat: ChatIcon,
  question: QuestionIcon,
  en: EnglishIcon,
  fr: FrenchIcon,
  sv: SwedishIcon,
  de: GermanIcon,
  es: SpanishIcon,
  bar: BarIcon,
  chart: ChartIcon,
  'chart-line': ChartLineIcon,
  'chart-pie': ChartPieIcon,
  calendar: CalendarIcon,
  hourglass: HourglassIcon,
  'time-clock:': TimeClockIcon,
  message: MessageIcon,
  paperplane: PaperplaneIcon,
  receipt: ReceiptIcon,
  mail: MailIcon,
  megaphone: MegaphoneIcon,
  'phone-call': PhoneCallIcon,
  mic: MicrophoneIcon,
  headphones: HeadphonesIcon,
  user: UserIcon,
  globe: GlobeIcon,
  'emoji-big-smile': EmojiBigSmileIcon,
  'emoji-smile': EmojiSmileIcon,
  'emoji-sad': EmojiSadIcon,
  heart: HeartIcon,
  tree: TreeIcon,
  file: FileIcon,
  search: SearchIcon,
  compass: CompassIcon,
} as const;
